import { useState } from 'react';

import { MessageInstance } from 'antd/es/message/interface';
import i18n from 'i18next';

import { ApiErrorData } from 'models/ApiResponse';

import { KitCampaignService } from 'services/KitCampaignService';

import { AttendanceUserTurnDetail } from '../types';

const BASE = 'scenes.kit.dashboard_alternative_mode.components.evidence_modal';

interface UseEvidenceModalParams {
  message: MessageInstance;
}

export interface UseEvidenceModalReturn {
  open: boolean;
  loading: boolean;
  detail: AttendanceUserTurnDetail | undefined;
  openModal: (userId: number, turnId: number) => Promise<void>;
  closeModal: () => void;
}

export function useEvidenceModal({
  message,
}: UseEvidenceModalParams): UseEvidenceModalReturn {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [detail, setDetail] = useState<AttendanceUserTurnDetail | undefined>(
    undefined
  );

  const openModal = async (userId: number, turnId: number) => {
    setDetail(undefined);
    setOpen(true);
    setLoading(true);

    const response =
      await KitCampaignService.findAttendanceUserTurnDetailByCompositeKey({
        userId,
        turnId,
      });

    if (response.success) {
      setDetail(response.data as AttendanceUserTurnDetail);
    } else {
      const error = response.data as ApiErrorData;
      message.error(
        (error.message as string) || i18n.t(`${BASE}.errors.fetch_failed`),
        3.5
      );
      setOpen(false);
    }

    setLoading(false);
  };

  const closeModal = () => {
    setOpen(false);
    setDetail(undefined);
  };

  return { open, loading, detail, openModal, closeModal };
}
